import { CalendarDays } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import { Calendar } from '@nesso/ui/primitives/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@nesso/ui/primitives/popover';

import { formatShortDate } from '@/shared/lib/time-utils';

type Props = {
    value: Date | undefined;
    onChange: (date: Date | undefined) => void;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    minDate?: Date;
    defaultMonth?: Date;
    placeholder?: string;
    disabled?: boolean;
};

export function NessoPlanDatePicker({
    value,
    onChange,
    open,
    onOpenChange,
    minDate,
    defaultMonth,
    placeholder = 'Pick a date',
    disabled,
}: Props) {
    return (
        <Popover open={disabled ? false : open} onOpenChange={disabled ? undefined : onOpenChange}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    disabled={disabled}
                    className="justify-start w-60 h-10 bg-background border-input text-base font-normal"
                >
                    <div className="flex items-center gap-2">
                        <CalendarDays className="h-4 w-4 text-muted-foreground" />
                        <span>{value ? formatShortDate(value) : placeholder}</span>
                    </div>
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                    mode="single"
                    className="w-60"
                    selected={value}
                    onSelect={onChange}
                    defaultMonth={defaultMonth ?? value}
                    disabled={minDate ? { before: minDate } : undefined}
                />
            </PopoverContent>
        </Popover>
    );
}
